<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Unidades Escolares</span>
        <e-help-tooltip :text="$constants.tooltips.administracao.criarFranquia" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn color="success" @click="criarFranquia" class="mr-2">Criar Unidade Escolar</v-btn>
          <v-text-field
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            autofocus
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="franquiasList"
          :loading="carregandoFranquias"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="franquia.estaDeletado ? ['deleted'] : []"
                v-for="franquia of items"
                :key="franquia.id"
              >
                <td>{{ franquia.id }}</td>
                <td>{{ franquia.codigo }}</td>
                <td>{{ franquia.descricao }}</td>
                <td>{{ franquia.cidade }}</td>
                <!-- <td>{{ franquia.contexto }}</td> -->
                <td>
                  <v-tooltip v-if="!franquia.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => editarFranquia(franquia)"
                      >
                        <v-icon small>fa fa-edit </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar unidade escolar</span>
                  </v-tooltip>
                  <v-tooltip v-if="!franquia.estaDeletado" color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => deletarFranquia(franquia)"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Apagar unidade escolar</span>
                  </v-tooltip>
                  <v-tooltip v-if="franquia.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => recuperarFranquia(franquia)"
                      >
                        <v-icon small>fa fa-sync </v-icon>
                      </v-btn>
                    </template>
                    <span>Recuperar unidade escolar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="listarFranquias"
          :search="search"
        ></e-paginate>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { dataTableFilter } from "@/plugins/searchQuery";
import Franquia from "@/Models/Franquia";

export default {
  computed: {
    ...mapGetters("Franquias", ["franquias", "carregandoFranquias, franquiasList"]),
  },
  data() {
    return {
      dataTableFilter,
      search: "",
      franquiasList: [],
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Código", value: "codigo" },
          { text: "Unidade", value: "descricao" },
          { text: "Cidade", value: "cidade" },
          // { text: "Contexto", value: "contexto" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  watch: {
    carregandoFranquias(value) {
      if (value && this.franquiasList.length === 0) {
        this.$loaderService.open("Carregando Unidades Escolares");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val.length > 2) {
        await this.listarFranquias(0, val);
      }
      if (!val) {
        await this.listarFranquias(0);
      }
    },
  },
  mounted() {
    this.carregandoFranquias = true;
    this.$store.dispatch("Franquias/loadFranquias");
    this.listarFranquias(this.pageNumber);
    this.carregandoFranquias = false;
  },
  methods: {
    criarFranquia() {
      this.$router.push({ name: "franquias.create" });
    },
    async listarFranquias(pageNumber, query = null) {
      this.carregandoFranquias = true;
      try {
        const response = await this.$services.franquiasService.syncAllPaginated(pageNumber, query);
        this.franquiasList = await response.data.map((franquia) => new Franquia(franquia));
        this.paginate = response;
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoFranquias = false;
    },
    editarFranquia(franquia) {
      this.$router.push({ name: "franquias.edit", params: { franquia_id: franquia.id } });
      // return franquia;
    },
    async deletarFranquia(franquia) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta unidade escolar?",
        confirmationCode: franquia.id,
        confirmationMessage: `Por favor, digite <strong>${franquia.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando a Unidade Escolar");
              try {
                await this.$services.franquiasService.deletarFranquia(franquia);
                this.$toast.success("Unidade Escolar deletada com sucesso");
                await this.listarFranquias();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    recuperarFranquia(franquia) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar esta Unidade Escolar?",
        confirmationCode: franquia.id,
        confirmationMessage: `Por favor, digite <strong>${franquia.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando a Unidade Escolar");
              try {
                await this.$services.franquiasService.recuperarFranquia(franquia);
                this.$toast.success("Unidade Escolar recuperada com sucesso");
                await this.listarFranquias();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style></style>
